import { render } from "./Transcript.vue?vue&type=template&id=0f934521"
import script from "./Transcript.vue?vue&type=script&lang=js"
export * from "./Transcript.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__